import * as React from "react";
import { ViewType } from "../../../NewsroomView";
import ArchiveButton from "../../RenderComponents/ArchiveButton";
import DeleteButton from "../../RenderComponents/DeleteButton";
import EditButton from "../../RenderComponents/EditButton";
import BackButton from "./BackButton";

interface IProps {
    config: any;
    post: any;
    isAdmin: boolean;
    onDelete: (newsId, isDeleted, isPermanent) => void;
    onSwitchView: (view: ViewType, newsId?: string) => void;
}

const ButtonBar = (props: IProps) => {
    return (
        <>
            <div className="CMS_buttonBar">
                <div>
                    <BackButton onBack={() => props.onSwitchView(ViewType.Summary)} />
                </div>
                {props.isAdmin && props.post ? <div className="CMS_bbControls">
                    <EditButton
                        isAdmin={props.isAdmin}
                        config={props.config}
                        post={props.post}
                        showIcon={true}
                        onSwitchView={props.onSwitchView}
                    />&nbsp;
                    <ArchiveButton
                        isAdmin={props.isAdmin}
                        post={props.post}
                        onDelete={props.onDelete}
                        showIcon={true}
                    />
                    <DeleteButton
                        isAdmin={props.isAdmin}
                        post={props.post}
                        onDelete={props.onDelete}
                        showIcon={true}
                    />
                </div> : null}
            </div>
        </>
    );
};

export default ButtonBar;
